import useWalletCurrency from '~/client/hooks/currency/useWalletCurrency';
import useCashierLink from '~/client/hooks/feature/useCashierLink';
import useUserBalance from '~/client/hooks/user/useUserBalance';
import useSite from '~/client/hooks/useSite';

const useDepositButton = () => {
  const wallet = useWalletCurrency();
  const { totalBalance } = useUserBalance(wallet);
  const isZeroBalance = totalBalance === 0;
  const { site } = useSite();
  const isEmpire = site === 'empire';
  const cashierPath = isEmpire ? 'deposit' : 'home';
  const { onClick } = useCashierLink({ cashierPath });
  return { isZeroBalance, onClick };
};

export default useDepositButton;
